import { render } from "./Translate.vue?vue&type=template&id=068e70c6"
import script from "./Translate.vue?vue&type=script&lang=js"
export * from "./Translate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__